/* talk·point — Hover waehrend des Scrollens aussetzen (IT#16835, Teil 3).
   Beim Scrollen rutschen laufend neue Karten unter den ruhenden Cursor. Jede startet
   ihre Hover-Transition (transform/border-color/box-shadow/filter) — nicht compositbar,
   also Neu-Rasterung der betroffenen Kacheln bei 2x DPR in jedem Frame. Gemessen auf der
   Startseite (1680x1739@2x): GPU 2254 ms und 26 Frames > 100 ms je Scroll-Lauf mit Cursor
   ueber den Karten, 372 ms / 4 Frames mit Cursor am Rand. Waehrend eines Scrolls bekommt
   <html> die Klasse tp-scrolling; CSS (tp-components.css) nimmt dem Seiteninhalt die
   pointer-events, der Scroller .page-wrapper bleibt Wheel-Ziel. 150 ms nach dem letzten
   Scroll-Event ist Hover wieder da. Nur der Seiten-Scroller zaehlt — Karussell-Tracks
   nicht, sonst schluckt ein laufendes scrollBy den zweiten Klick auf den Pfeil. */
(function () {
  if (window.__tpScrollIdle) return;
  window.__tpScrollIdle = true;
  var root = document.documentElement, timer = 0, on = false, IDLE_MS = 150;
  function isPageScroller(t) {
    return t === document || t === root || t === document.body ||
      (t && t.nodeType === 1 && t.classList && t.classList.contains('page-wrapper'));
  }
  function onScroll(e) {
    if (!isPageScroller(e.target)) return;
    if (!on) { on = true; root.classList.add('tp-scrolling'); }
    clearTimeout(timer);
    timer = setTimeout(function () { on = false; root.classList.remove('tp-scrolling'); }, IDLE_MS);
  }
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
})();
